import gatewayLSPaymentsViewTemplate from './templates/gateway-lspayments-view.hbs';
import BaseLayoutView from 'app/src/views/base/BaseLayoutView';

// configure
let View = BaseLayoutView.extend({
  template: gatewayLSPaymentsViewTemplate,
});

// define
export default class GatewayLSPaymentView extends View {}
